<div class="container-fluid">
  <div class="row justify-content-center">
    <div class="col-sm-10 col-md-6 col-lg-4 g-0">
      <div class="card my-3">
        <app-user-title title="wachtwoord wijzigen" [icon]="faKey">
        </app-user-title>
        @if(!processing()) {
          <div class="card-body card-body-auth">
            @if(alert) {
            <ngb-alert [type]="alert.type">{{ alert.message }}</ngb-alert>
            } 
            @if(isLoggedIn()) {
              @if(passwordChanged) {
                <div class="card card-body mx-auto bg-faded form-password-change mt-3">
                  <legend class="m-b-1 text-xs-center">het wachtwoord is gewijzigd en je bent ingelogd!</legend>
                  <button role="button" class="btn btn-outline-secondary" [routerLink]="['/']">ga verder</button>
                </div>
              } @else {
                <div class="card card-body mx-auto bg-faded form-password-change mt-3">
                  <legend class="m-b-1 text-xs-center">je bent al ingelogd</legend>
                  <button role="button" class="btn btn-outline-secondary" [routerLink]="['/']">ga terug</button>
                </div>
              }
            } @else if(!passwordChanged) {
              <form name="form" (ngSubmit)="changePassword()" [formGroup]="form" novalidate>
                <div class="form-group row">
                  <div class="col-3">
                    <label for="code" class="col-form-label">code</label>
                  </div>
                  <div class="col-9 mb-3">
                    <input class="form-control"
                      ngClass="{ 'is-invalid': form.controls.code.invalid, 'is-valid': form.controls.code.valid }" type="number"
                      formControlName="code" [min]="validations.minlengthcode" [max]="validations.maxlengthcode">
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-3">
                    <label for="password" class="col-form-label">wachtwoord</label>
                  </div>
                  <div class="col-9 mb-3">
                    <input class="form-control"
                      ngClass="{ 'is-invalid': form.controls.password.invalid, 'is-valid': form.controls.password.valid }"
                      type="password" formControlName="password" placeholder="min. {{validations.minlengthpassword}} karakters">
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-3">
                    <label for="passwordRepeat" class="col-form-label">herhaal wachtwoord</label>
                  </div>
                  <div class="col-9 mb-3">
                    <input class="form-control"
                      ngClass="{ 'is-invalid': form.controls.passwordRepeat.invalid, 'is-valid': form.controls.passwordRepeat.valid }"
                      type="password" formControlName="passwordRepeat" placeholder="min. {{validations.minlengthpassword}} karakters">
                  </div>
                </div>
                <div class="form-group row justify-content-end">
                  <div class="col-9">
                    <button [disabled]="form.invalid" type="submit" class="btn btn-primary">
                      wachtwoord wijzigen
                    </button>
                  </div>
                </div>
              </form>
            }            
          </div>
        } @else {
        <h2 class="text-center">
          <fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>
        </h2>
        }
    </div>
  </div>
</div>